<div class="frame-in">
  <div class="items zone-6-frame">
    <svg class="road zone-6">
      <g id="GAME UI">
        <g id="EUROPE ZONES">
          <g id="EUROPE ZONES">
            <g id="EUROPE ZONES">
              <g id="ZONE2">
                <g id="Track lines ZONE4 copy">
                  <path id="Shape 3963" class="shp0" d="M198 287C198 287 201.51 313.01 235 322C268.49 330.99 281.53 344.51 284 366" />
                  <path id="Shape 3963 copy" class="shp0" d="M285.08 390.38C284.45 404.96 280.88 417.78 271 420C255.65 423.45 217.58 426.47 209 450" />
                  <path id="Shape 3964" class="shp0" d="M197 241C197 241 239.21 187.64 378 243C510.57 295.88 614.98 265.48 600 188" />
                  <path id="Shape 3965" class="shp0" d="M216 20C216 20 342.34 -21.65 480 16C569.12 40.37 602 163 602 163" />
                  <path id="Shape 3966" class="shp0" d="M181 44C162.6 55.89 148.3 112.88 79.83 93.92C79.83 93.92 25.93 83.33 18 112" />
                  <path id="Shape 1689" class="shp0" d="M1 134C1 134 0.56 163.45 18 185" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg class="road zone-6-1">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp0 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <g id="GAME UI">
    <g id="EUROPE ZONES">
      <g id="EUROPE ZONES">
        <g id="EUROPE ZONES">
          <path id="Track lines ZONE 3" class="shp0" d="M142 1C142 1 152.45 55.17 117 66C81.55 76.83 37.95 80.89 -5 68" />
        </g>
      </g>
    </g>
  </g>
</svg>
<div class="country zone-6">
</div>

@for (zone of zones; track zone) {
  <div>
    <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
  </div>
}

<div class="country zone-6-germany"></div>
<div class="country zone-6-bosnia"></div>

<div class="poi quiz quiz-1"></div>
@for (zone of zones; track zone; let i = $index) {
  <div
    class="poi {{zone.class}}"
    [ngClass]="{active: zone.active, 'lock': zone.locked}"
    (mouseenter)="mouseEnter(zone)"
    (mouseleave)="mouseLeave(zone)"
    (click)="selectZone(zone)"><span>{{ zone.locked ? '' : zone.number}}</span></div>
  }
  <div class="poi quiz quiz-2" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 6, 'active': quizLevel === 6 && tick2Quiz}"></div>
</div>
</div>

<img class="frame-title" src="assets/images/zones/5/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('2-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('2-1')) {
        <a class="menu-item" [routerLink]="[ '/game/zone5' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('2-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('2-2')) {
        <a class="menu-item" [routerLink]="[ '/game/zone6' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('2-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('2-3')) {
        <a class="menu-item" [routerLink]="[ '/game/zone7' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/6/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
